import React, { Component } from 'react'
import { Goods } from '@/components/goods'
import { AddCart } from './components/add-cart'
import { Tabs, Toast, Modal } from 'antd-mobile'
import { connect } from 'react-redux'
import { fetchNavlist as fetchNavlistApi } from '@/api/store'
import {
  fetchGoods as fetchGoodsApi,
  fetchGoodsCount as fetchGoodsCountApi,
} from '@/api/store'
import StoresHeader from '@/components/store-header'
import { setHeader } from '@/util/set-header'
import { GOODS_SET_COUNT } from '@/action-types/goods'

import { withActivation } from 'react-activation'
import './store.less'

interface Props {
  depot_id: string
  is_rest: boolean
  title: string
  setGoodsCountAction: (count: string | number) => any
}

const mapStateToProps = (state: any) => {
  return {
    depot_id: state.depot.id,
    is_rest: state.depot.is_rest,
    title: state.depot.title
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  setGoodsCountAction: (count: string | number) =>
    dispatch({ type: GOODS_SET_COUNT, count }),
})

@(connect(
  mapStateToProps,
  mapDispatchToProps,
) as any)
@(withActivation as any)
export default class Store extends Component<Props | any, any> {
  state: any = {
    activeTab: '',
    tabs: [],
    addCarting: false,
    storeName: '',
    restModalVisible: false,
  }
  tween: any = {}
  goodsRefs: any = {}
  private touchPos: any = {
    startX: 0,
    startY: 0,
    moveEndX: undefined,
    moveEndY: undefined,
    X: 0,
    Y: 0,
    direction: 0,
    lrLock: false,
    tbLock: false,
  }

  componentDidActivate() {
    setHeader({ nav: <StoresHeader /> })
    if (window.WebViewBridge) {
      window.WebViewBridge.shouldShowTabBar(true)
    } else if (window.webkit) {
      window.webkit.messageHandlers.shouldShowTabBar.postMessage(true);
    }
  }

  componentWillUnactivate() {
    if (window.WebViewBridge) {
      window.WebViewBridge.shouldShowTabBar(false)
    } else if (window.webkit) {
      window.webkit.messageHandlers.shouldShowTabBar.postMessage(false);
    }
  }

  UNSAFE_componentWillMount() {
    setHeader({ nav: <StoresHeader /> })
  }
  componentWillUnmount() {
    if (window.WebViewBridge) {
      window.WebViewBridge?.shouldShowTabBar?.call(window.WebViewBridge, false)
    } else if (window.webkit) {
      window.webkit.messageHandlers.shouldShowTabBar.postMessage(false)
    }
  }
  componentDidMount() {
    if (window.WebViewBridge) {
      window.WebViewBridge?.shouldShowTabBar?.call(window.WebViewBridge, true)
    } else if (window.webkit) {
      window.webkit.messageHandlers.shouldShowTabBar.postMessage(true)
    }
    const { depot_id } = this.props
    if (depot_id) {
      this.setTabs(depot_id)
      this.getGoodsCount(depot_id)
    }
  }
  setTabs = async (depot_id: string) => {
    let { data, code, msg } = await fetchNavlistApi(depot_id)
    if (code !== 'SUCCESS') {
      Toast.info(msg, 2)
      return
    }
    const tabs = data.map((tab: { id: string; name: string }) => ({
      title: <span>{tab.name}</span>,
      key: tab.id,
      ...tab,
    }))
    const activeTab = tabs[0].key
    this.setState({ tabs, activeTab })
  }
  getGoodsCount = async (depot_id: string) => {
    const { setGoodsCountAction } = this.props
    const { data } = await fetchGoodsCountApi(depot_id)

    if (data.code === 'SUCCESS') {
      setGoodsCountAction(data.data)
    }
  }
  componentWillReceiveProps(nextProps: Props) {
    const nextDepotId = nextProps.depot_id
    const is_rest = nextProps.is_rest
    const { depot_id } = this.props
    if (is_rest) {
      this.setState({
        restModalVisible: true,
        title: nextProps.title
      })
    }
    if (depot_id !== nextDepotId) {
      this.setTabs(nextDepotId)
      this.getGoodsCount(nextDepotId)
    }
  }
  onClose() {
    this.setState({
      restModalVisible: false
    })
  }
  render() {
    const { depot_id } = this.props
    const { tabs } = this.state
    return (
      <div>
        <div className="body">
          <div className="tabs">
            <Tabs
              tabs={tabs}
              initialPage={0}
              onChange={() => {
                // console.log('onChange', index, tab)
                if (window.WebViewBridge?.eventLabel) {
                  window.WebViewBridge?.eventLabel('click_Store_classification', '')
                } else if (window.webkit) {
                  window.webkit.messageHandlers.eventLabel.postMessage({ 'id': 'click_Store_classification' })
                }
              }}
            >
              {depot_id &&
                tabs.map((tab: { id: string; name: string }) => {
                  return (
                    <div key={tab.id}>
                      <Goods
                        key={`${depot_id}-${tab.id}`}
                        id={tab.id}
                        api={(params: any = {}) => {
                          return new Promise(suc => {
                            const param = {
                              depot_id: depot_id,
                              cid: tab.id,
                            }
                            fetchGoodsApi({
                              ...params,
                              ...param,
                            }).then(({ data, code, msg }) => {
                              if (code !== 'SUCCESS') {
                                Toast.info(msg, 2)
                                return
                              }
                              suc(
                                data.filter(
                                  (good: any) => good.module === 'goods_list',
                                )[0].data,
                              )
                              // 展示休息弹框
                              let list: any[] = data.filter(
                                (good: any) => good.module === 'goods_list',
                              )[0].data
                              if (list.length > 0) {
                                let rest = list[0].is_rest
                                if (rest) {
                                  this.setState({
                                    restModalVisible: true,
                                    title: this.props.title
                                  })
                                }
                              }
                            })
                          })
                        }}
                        addCart={(dom: any) => {
                          this.tween = {
                            dom: dom,
                          }
                          this.setState({ addCarting: true })
                        }}
                      />
                    </div>
                  )
                })}
            </Tabs>
          </div>
        </div>
        {this.state.addCarting && (
          <AddCart
            dom={this.tween.dom}
            onStop={() => this.setState({ addCarting: false })}
          />
        )}
        <Modal
          visible={this.state.restModalVisible}
          transparent
          maskClosable={true}
          closable={true}
          onClose={this.onClose.bind(this)}
        >
          <div className="rest-modal" >
            <img style={{ width: '50px', height: '50px' }} src="/public/assets/img/info_icon.png" alt="" />
            <span style={{ color: '#484848' }}>{this.state.title}</span>
            <span>请营业时间再来看看哦~</span>
          </div>
        </Modal>
      </div>
    )
  }
}
